<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Datatable from "@/router/layouts/table-datatable";
import Pagination from "@/router/layouts/table-pagination";
import ModalFormTresholdAnalisaSoal from "./modal-form-treshold-analisa-soal.vue";
import axios from "axios";
import Swal from "sweetalert2";
import _ from "lodash";

export default {
  page: {
    title: "Treshold Analisa Soal",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Datatable,
    Pagination,
    ModalFormTresholdAnalisaSoal,
  },
  data() {
    let sortOrders = []; // select sortOrder
    let columns = [
      {
        width: "50px",
        label: "No",
        name: "-",
      },
      {
        width: "auto",
        label: "Persentase Bawah",
        name: "persentase_bawah",
      },
      {
        width: "auto",
        label: "Persentase atas",
        name: "persentase_atas",
      },
      {
        width: "auto",
        label: "Keterangan",
        name: "keterangan",
      },
      {
        width: "180px",
        label: "Aksi",
        name: "-",
      },
    ];
    const menu = "Treshold Analisa Soal";

    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    return {
      title: menu,
      showModal: false,
      titleModal: "",
      typeModal: "add",
      loadingTable: false,
      columns: columns,
      sortKey: "idtreshold_analisa_soal",
      sortOrders: sortOrders,
      currentTablePage: "",
      tableData: [],
      tableFilter: {
        page: 1,
        draw: 0,
        per_page: 10,
        search: "",
        column: 0,
        dir: "asc",
        persentase_bawah: "",
        persentase_atas: "",
        keterangan: "",
        filter_status: "all", // untuk filtering data
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },
    };
  },
  methods: {
    async getDataTable(resetPage = true) {
      this.tableFilter.page = resetPage ? 1 : this.tableFilter.page;
      this.loadingTable = true;
      this.tableData = []; // Reset table data before fetching new data
      const config = {
        method: "get",
        url: `${process.env.VUE_APP_BACKEND_URL_VERSION}master/treshold-analisa-soal`,
        params: this.tableFilter,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      };
      await axios(config)
        .then((response) => {
          if (response.data.meta.code == 200) {
            this.tableData = response.data.data.data.data;

            this.configPagination(response.data.data.data);
            this.currentTablePage = response.data.data.data.current_page;
            this.loadingTable = false;
          } else {
            this.loadingTable = false;
            Swal.fire({
              icon: "error",
              title: "Error",
              text: response.data.meta.message,
            });
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          this.loadingTable = false;
        });
    },
    configPagination(data) {
      this.pagination.lastPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.total = data.total;
      this.pagination.lastPageUrl = data.last_page_url;
      this.pagination.nextPageUrl = data.next_page_url;
      this.pagination.prevPageUrl = data.prev_page_url;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
      this.pagination.links = data.links;
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableFilter.column = key;
      this.tableFilter.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      this.getDataTable();
    },
    getIndex(array, key, value) {
      return array.findIndex((i) => i[key] == value);
    },
    toPage(url) {
      let link = new URLSearchParams(url);
      this.tableFilter.page = link.get("page");
      // this.tableFilter.per_page = link.get('per_page');
      this.getDataTable(false);
    },
    exportData() {
      let params = new URLSearchParams(this.tableFilter).toString();
      window.open(
        process.env.VUE_APP_BACKEND_URL_VERSION +
          "export-excel/treshold-analisa-soal?" +
          params
      );
    },
    addData() {
      this.titleModal = "Tambah Data Treshold Analisa Soal";
      this.typeModal = "add";
      this.dataModal = null;
      this.showModal = true;
    },
    editData(row) {
      this.titleModal = "Edit Data Treshold Analisa Soal";
      this.typeModal = "edit";
      this.dataModal = row;
      this.showModal = true;
    },
    deleteData(id) {
      Swal.fire({
        icon: "question",
        title: "Apakah Anda yakin menghapus data ini ?",
        text: "Data yang terhapus tidak dapat dipulihkan kembali!",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `Iya`,
        denyButtonText: `Tidak`,
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: '<i class="fas fa-spinner fa-spin"></i>',
            text: "Loading...",
            showConfirmButton: false,
            allowOutsideClick: false,
          });

          axios({
            method: "delete",
            url:
              process.env.VUE_APP_BACKEND_URL_VERSION +
              "master/treshold-analisa-soal/" +
              id,
            data: {
              id: id,
            },
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token,
            },
          }).then((response) => {
            let response_data = response.data;
            if (response_data.meta.code != "200") {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: response_data.data.message,
              });
            } else {
              Swal.fire({
                icon: "success",
                title: "Berhasil",
                text: "Data berhasil dihapus.",
                timer: 2000,
                timerProgressBar: true,
                showCancelButton: false,
                showConfirmButton: false,
              }).then((result) => {
                if (result.dismiss) {
                  this.getDataTable();
                }
              });
            }
          });
        } else {
          Swal.close();
        }
      });
    },
  },
  mounted() {
    this.getDataTable();
    this.filterData = _.debounce(this.getDataTable.bind(this), 500);
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12 d-flex justify-content-between">
                <h4 class="card-title">Daftar Treshold Analisa Soal</h4>
                <div class="d-flex gap-2">
                  <button class="btn btn-success btn-sm" @click="exportData()">
                    <i class="fa fa-file-excel"></i> Export Excel
                  </button>
                  <button class="btn btn-primary btn-sm" @click="addData()">
                    <i class="fa fa-plus"></i> Tambah Data
                  </button>
                </div>
              </div>
              <div class="col-md-12">
                <hr />
                <div class="row">
                  <div class="form-group col-md-4">
                    <label form="filterPersentaseBawah">Persentase Bawah</label>
                    <input
                      type="text"
                      class="form-control"
                      id="filterPersentaseBawah"
                      placeholder="Filter Persentase Bawah"
                      v-model="tableFilter.persentase_bawah"
                      @input="filterData"
                    />
                  </div>
                  <div class="form-group col-md-4">
                    <label form="filterPersentaseAtas">Persentase Atas</label>
                    <input
                      type="text"
                      class="form-control"
                      id="filterPersentaseAtas"
                      placeholder="Filter Persentase Atas"
                      v-model="tableFilter.persentase_atas"
                      @input="filterData"
                    />
                  </div>
                  <div class="form-group col-md-4">
                    <label form="filterKeterangan">Keterangan</label>
                    <input
                      type="text"
                      class="form-control"
                      id="filterKeterangan"
                      placeholder="Filter Keterangan"
                      v-model="tableFilter.keterangan"
                      @input="filterData"
                    />
                  </div>
                </div>
                <hr />
              </div>
              <div class="col-md-12 mb-2">
                <div class="row">
                  <div class="col-md-4">
                    <table>
                      <tr>
                        <td>Show</td>
                        <td>
                          <select
                            class="form-control form-control-sm"
                            v-model="tableFilter.per_page"
                            @change="getDataTable()"
                          >
                            <option value="10" selected>10</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                            <option value="200">200</option>
                            <option value="500">500</option>
                          </select>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
              <datatable
                :columns="columns"
                :sortKey="sortKey"
                :sortOrders="sortOrders"
                @sort="sortBy"
              >
                <tbody>
                  <tr v-if="loadingTable">
                    <td colspan="99" class="text-center">
                      <i class="fas fa-spinner fa-spin"></i> Loading...
                    </td>
                  </tr>
                  <tr v-else-if="tableData.length == 0">
                    <td colspan="99" class="text-center">
                      Data tidak tersedia
                    </td>
                  </tr>
                  <tr
                    v-else
                    v-for="(row, key) in tableData"
                    :key="row.idklasifikasi_skor"
                  >
                    <td>
                      <span v-if="key + 1 == 10">
                        {{ currentTablePage }}0.
                      </span>
                      <span v-else>
                        {{
                          currentTablePage - 1 != 0 ? currentTablePage - 1 : ""
                        }}
                        {{ key + 1 }}.
                      </span>
                    </td>
                    <td>
                      {{ row.persentase_bawah }}
                    </td>
                    <td>
                      {{ row.persentase_atas }}
                    </td>
                    <td>
                      {{ row.keterangan }}
                    </td>
                    <td class="text-center">
                      <div class="btn-group btn-group-sm">
                        <button
                          class="btn btn-warning btn-sm"
                          @click="editData(row)"
                        >
                          <i class="fa fa-edit"></i> Edit
                        </button>
                        <button
                          class="btn btn-danger btn-danger"
                          @click="deleteData(row.idtreshold_analisa_soal)"
                        >
                          <i class="fas fa-trash"></i> Hapus
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </datatable>
            </div>
            <pagination :pagination="pagination" @to-page="toPage"></pagination>
          </div>
        </div>
      </div>
    </div>
  </Layout>
  
  <b-modal v-model="showModal" :title="titleModal" hide-footer>
    <ModalFormTresholdAnalisaSoal
      :typeTrans="typeModal"
      :dataTresholdAnalisa="dataModal"
      @submitForm="
        getDataTable();
        showModal = false;
      "
    ></ModalFormTresholdAnalisaSoal>
  </b-modal>
</template>
